"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var isPlainObject_1 = __importDefault(require("lodash/isPlainObject"));

var async_foreach_1 = __importDefault(require("@widget-editor/shared/lib/helpers/async-foreach"));

var constants_1 = require("../helpers/wiget-helper/constants");

var fields_1 = __importDefault(require("./fields"));

var FiltersService =
/*#__PURE__*/
function () {
  function FiltersService(store, adapter) {
    _classCallCheck(this, FiltersService);

    var configuration = store.configuration,
        filters = store.filters,
        dataset = store.editor.dataset,
        endUserFilters = store.endUserFilters;
    this.configuration = configuration;
    this.filters = filters.list;
    this.sql = "";
    this.adapter = adapter;
    this.endUserFilters = endUserFilters;
    this.dataset = dataset;

    if (this.hasRequiredFields()) {
      this.prepareSelectStatement();
      this.prepareFilters();
      this.prepareGroupBy();
      this.prepareOrderBy();
      this.prepareLimit();
    }
  }

  _createClass(FiltersService, [{
    key: "hasRequiredFields",
    value: function hasRequiredFields() {
      var _a, _b, _c, _d;

      return ((_b = (_a = this.configuration) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.name) && ((_d = (_c = this.configuration) === null || _c === void 0 ? void 0 : _c.category) === null || _d === void 0 ? void 0 : _d.name);
    }
  }, {
    key: "resolveTableName",
    value: function resolveTableName() {
      return this.dataset.attributes.tableName;
    }
  }, {
    key: "prepareColor",
    value: function prepareColor() {
      var color = this.configuration.color;

      if (isPlainObject_1["default"](color)) {
        return ", ".concat(color.name, " as color");
      }

      return "";
    }
  }, {
    key: "resolveAggregate",
    value: function resolveAggregate(column) {
      var aggregateFunction = this.configuration.aggregateFunction;

      if (aggregateFunction) {
        return "".concat(aggregateFunction, "(").concat(column, ")");
      }

      return column;
    }
  }, {
    key: "resolveEndUserFilters",
    value: function resolveEndUserFilters() {
      if (this.endUserFilters.length) {
        return ", ".concat(this.endUserFilters);
      }

      return '';
    }
  }, {
    key: "prepareSelectStatement",
    value: function prepareSelectStatement() {
      var _this$configuration = this.configuration,
          category = _this$configuration.category,
          value = _this$configuration.value;
      this.sql = "SELECT ".concat(category.name, " as ").concat(constants_1.sqlFields.value, " ").concat(this.prepareColor(), " ").concat(this.resolveEndUserFilters());
      this.sql = "".concat(this.sql, ", ").concat(this.resolveAggregate(value.name), " as ").concat(constants_1.sqlFields.category, " FROM ").concat(this.resolveTableName());
    }
  }, {
    key: "getNumberFilterQuery",
    value: function getNumberFilterQuery(filter) {
      var column = filter.column,
          operation = filter.operation,
          value = filter.value;
      var sql;

      switch (operation) {
        case 'not-between':
          sql = "".concat(column, " < ").concat(value[0], " OR ").concat(column, " > ").concat(value[1]);
          break;

        case '>':
          sql = "".concat(column, " > ").concat(value);
          break;

        case '>=':
          sql = "".concat(column, " >= ").concat(value);
          break;

        case '<':
          sql = "".concat(column, " < ").concat(value);
          break;

        case '<=':
          sql = "".concat(column, " <= ").concat(value);
          break;

        case '=':
          sql = "".concat(column, " = ").concat(value);
          break;

        case '!=':
          sql = "".concat(column, " <> ").concat(value);
          break;

        case 'between':
        default:
          sql = "".concat(column, " >= ").concat(value[0], " AND ").concat(column, " <= ").concat(value[1]);
          break;
      }

      return sql;
    }
  }, {
    key: "getDateFilterQuery",
    value: function getDateFilterQuery(filter) {
      var _this = this;

      var column = filter.column,
          operation = filter.operation,
          value = filter.value;

      var getSerializedValue = function getSerializedValue(date) {
        return _this.dataset.attributes.provider === 'featureservice' ? "date '".concat(date.toISOString().split('T')[0], "'") : "'".concat(date.toISOString(), "'");
      };

      var sql;

      switch (operation) {
        case 'not-between':
          sql = "".concat(column, " < ").concat(getSerializedValue(value[0]), " OR ").concat(column, " > ").concat(getSerializedValue(value[1]));
          break;

        case '>':
          sql = "".concat(column, " > ").concat(getSerializedValue(value));
          break;

        case '>=':
          sql = "".concat(column, " >= ").concat(getSerializedValue(value));
          break;

        case '<':
          sql = "".concat(column, " < ").concat(getSerializedValue(value));
          break;

        case '<=':
          sql = "".concat(column, " <= ").concat(getSerializedValue(value));
          break;

        case '=':
          sql = "".concat(column, " = ").concat(getSerializedValue(value));
          break;

        case '!=':
          sql = "".concat(column, " <> ").concat(getSerializedValue(value));
          break;

        case 'between':
        default:
          sql = "".concat(column, " >= ").concat(getSerializedValue(value[0]), " AND ").concat(column, " <= ").concat(getSerializedValue(value[1]));
          break;
      }

      return sql;
    }
  }, {
    key: "getStringFilterQuery",
    value: function getStringFilterQuery(filter) {
      var column = filter.column,
          operation = filter.operation,
          value = filter.value;
      var sql;

      switch (operation) {
        case 'contains':
          sql = "".concat(column, " LIKE '%").concat(value, "%'");
          break;

        case 'not-contain':
          sql = "".concat(column, " NOT LIKE '%").concat(value, "%'");
          break;

        case 'starts-with':
          sql = "".concat(column, " LIKE '").concat(value, "%'");
          break;

        case 'ends-with':
          sql = "".concat(column, " LIKE '%").concat(value, "'");
          break;

        case '=':
          sql = "".concat(column, " LIKE '").concat(value, "'");
          break;

        case '!=':
          sql = "".concat(column, " NOT LIKE '").concat(value, "'");
          break;

        case 'by-values':
        default:
          sql = "".concat(column, " IN ('").concat(value.join('\', \''), "')");
          break;
      }

      return sql;
    }
  }, {
    key: "prepareFilters",
    value: function prepareFilters() {
      var _this2 = this;

      var _a;

      var sql = this.sql;
      var validFilters = ((_a = this.filters) !== null && _a !== void 0 ? _a : []).filter(function (filter) {
        return filter.value !== undefined && filter.value !== null && (!Array.isArray(filter.value) || filter.value.length > 0);
      });

      if (validFilters.length > 0) {
        sql = "".concat(sql, " WHERE ");
        validFilters.forEach(function (filter, index) {
          var column = filter.column,
              type = filter.type,
              notNull = filter.notNull;
          sql = index > 0 ? "".concat(sql, " AND ") : sql;

          if (type === 'number') {
            sql = "".concat(sql, " ").concat(_this2.getNumberFilterQuery(filter));
          } else if (type === 'date') {
            sql = "".concat(sql, " ").concat(_this2.getDateFilterQuery(filter));
          } else if (type === 'string') {
            sql = "".concat(sql, " ").concat(_this2.getStringFilterQuery(filter));
          }

          if (notNull) {
            sql = "".concat(sql, " AND ").concat(column, " IS NOT NULL");
          }
        });
      }

      this.sql = sql.replace(/ +(?= )/g, "");
    }
  }, {
    key: "prepareGroupBy",
    value: function prepareGroupBy() {
      var _this$configuration2 = this.configuration,
          aggregateFunction = _this$configuration2.aggregateFunction,
          color = _this$configuration2.color;

      if (!!aggregateFunction) {
        this.sql = "".concat(this.sql, " GROUP BY x");

        if (color === null || color === void 0 ? void 0 : color.name) {
          this.sql = "".concat(this.sql, ", color");
        }

        return;
      }
    }
  }, {
    key: "prepareOrderBy",
    value: function prepareOrderBy() {
      var _a, _b, _c, _d, _e, _f, _g, _h;

      var _this$configuration3 = this.configuration,
          orderBy = _this$configuration3.orderBy,
          chartType = _this$configuration3.chartType,
          aggregateFunction = _this$configuration3.aggregateFunction;
      var orderByField;

      if (orderBy) {
        var name = orderBy.name;
        orderByField = name || constants_1.sqlFields.category;
      } else if (chartType === "line" && ((_b = (_a = this.configuration) === null || _a === void 0 ? void 0 : _a.category) === null || _b === void 0 ? void 0 : _b.name)) {
        orderByField = this.configuration.category.name;
      } else if (["pie", "donut", "bar", "stacked-bar", "bar-horizontal", "stacked-bar-horizontal"].indexOf(chartType) !== -1 && ((_d = (_c = this.configuration) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.name)) {
        orderByField = this.configuration.value.name;
      }

      if (aggregateFunction && orderByField === ((_f = (_e = this.configuration) === null || _e === void 0 ? void 0 : _e.value) === null || _f === void 0 ? void 0 : _f.name) && ((_h = (_g = this.configuration) === null || _g === void 0 ? void 0 : _g.category) === null || _h === void 0 ? void 0 : _h.name) !== orderByField) {
        orderByField = 'y';
      }

      if (orderByField) {
        this.sql = "".concat(this.sql, " ORDER BY ").concat(orderByField, " ").concat((orderBy === null || orderBy === void 0 ? void 0 : orderBy.orderType) || 'desc');
      }
    }
  }, {
    key: "prepareLimit",
    value: function prepareLimit() {
      var _this$configuration$l = this.configuration.limit,
          limit = _this$configuration$l === void 0 ? 500 : _this$configuration$l;
      this.sql = "".concat(this.sql, " LIMIT ").concat(limit);
    }
  }, {
    key: "requestWidgetData",
    value: function requestWidgetData() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.dataset.id) {
                  _context.next = 2;
                  break;
                }

                throw new Error("Error, datasetId not present in Filters service.");

              case 2:
                _context.next = 4;
                return this.adapter.prepareRequest("https://api.resourcewatch.org/v1/query/".concat(this.dataset.id, "?sql=").concat(this.sql));

              case 4:
                response = _context.sent;
                return _context.abrupt("return", response.data);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "getQuery",
    value: function getQuery() {
      return encodeURIComponent(this.sql.replace(/ +(?= )/g, ""));
    }
  }], [{
    key: "getDeserializedFilters",
    value: function getDeserializedFilters(filters, fields, dataset) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3() {
        var _this3 = this;

        var res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                res = [];
                _context3.next = 3;
                return async_foreach_1["default"](filters, function (filter, index) {
                  return __awaiter(_this3, void 0, void 0,
                  /*#__PURE__*/
                  regeneratorRuntime.mark(function _callee2() {
                    var value, column, type, operation, notNull, defaultOperation, fieldService, deserializedValue;
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            value = filter.value, column = filter.name, type = filter.type, operation = filter.operation, notNull = filter.notNull;
                            defaultOperation = 'between';

                            if (type === 'string') {
                              defaultOperation = 'by-values';
                            }

                            fieldService = new fields_1["default"](dataset, fields);
                            deserializedValue = value;

                            if (type === 'date') {
                              deserializedValue = Array.isArray(value) ? value.map(function (v) {
                                return new Date(v);
                              }) : new Date(value);
                            }

                            _context2.t0 = res;
                            _context2.t1 = "we-filter-".concat(column, "-").concat(index);
                            _context2.t2 = column;
                            _context2.t3 = type;
                            _context2.t4 = operation !== null && operation !== void 0 ? operation : defaultOperation;
                            _context2.t5 = deserializedValue;
                            _context2.t6 = notNull;
                            _context2.next = 15;
                            return fieldService.getFieldInfo(column);

                          case 15:
                            _context2.t7 = _context2.sent;
                            _context2.t8 = {
                              id: _context2.t1,
                              column: _context2.t2,
                              type: _context2.t3,
                              operation: _context2.t4,
                              value: _context2.t5,
                              notNull: _context2.t6,
                              config: _context2.t7
                            };

                            _context2.t0.push.call(_context2.t0, _context2.t8);

                          case 18:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));
                });

              case 3:
                return _context3.abrupt("return", res);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
    }
  }, {
    key: "fetchConfiguration",
    value: function fetchConfiguration(dataset, fields, fieldName) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee4() {
        var fieldService, configuration;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                fieldService = new fields_1["default"](dataset, fields);
                _context4.next = 3;
                return fieldService.getFieldInfo(fieldName);

              case 3:
                configuration = _context4.sent;
                return _context4.abrupt("return", configuration);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
    }
  }]);

  return FiltersService;
}();

exports["default"] = FiltersService;